/** @jsx jsx */

import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import Promise from "bluebird";
import { withOnScreen } from "hocs/onScreen";
import times from "lodash/times";
import PropTypes from "prop-types";
import { Component } from "react";
import posed from "react-pose";
import { colors, grid } from "config";

const delay = 200;

const BarWrapper = styled.div`
    overflow: hidden; 
    margin: 10px 0;
`;

const Wrapper = styled.span`
    display: block;
    overflow: hidden;
    height: 16px;
    width: 14px;
    float: left;
    margin: 0 12px 0 0;
    
    ${grid.breakpoints.desktop} {
        margin: 0 8px 0 0;
    }
`;

const Fill = posed.rect({
    hidden: {
        width: 0
    },
    visible: {
        width: ({ width }) => width,
        transition: { duration: delay }
    }
});


class Bar extends Component {
    constructor () {
        super();

        this.state = {
            currentPercent: 0
        };
    }

    render () {
        return (
            <BarWrapper>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14">
                    <clipPath id={`circle-clip-path`}>
                        <path d="M12 4h2v6h-2v2h-2v2H4v-2H2v-2H0V4h2V2h2V0h6v2h2v2z"/>
                    </clipPath>
                </svg>
                {times(10).map((index) => (
                    <Wrapper key={index}>
                        {this.renderCircle(index)}
                    </Wrapper>
                ))}
            </BarWrapper>
        );
    }

    renderCircle (index) {
        const { currentPercent } = this.state;
        const width = Math.min(100, Math.max(0, currentPercent - ((index) * 10)) * 10);
        const ratio = width / 100;

        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14">
                <rect fill={colors.grey} x="0" y="0" width="14" height="14"
                      clipPath={`url(#circle-clip-path)`}/>
                <Fill fill={colors.blue} x="0" y="0" width={14 * ratio} height="14"
                      clipPath={`url(#circle-clip-path)`}
                      pose={width > 0 ? "visible" : "hidden"}/>
            </svg>
        );
    }

    shouldComponentUpdate ({ onScreen }) {
        if (onScreen !== this.props.onScreen) {
            this.animate()
                .then(this.props.animationFinished);
        }

        return true;
    }

    animate () {
        const { currentPercent } = this.state;
        const { percentage } = this.props;

        if (currentPercent < percentage) {
            this.setState({
                currentPercent: currentPercent + (Math.min(10, percentage - currentPercent))
            });

            return Promise.delay(delay)
                .then(() => this.animate());
        }

        return Promise.resolve();
    }

}

Bar.propTypes = {
    percentage: PropTypes.number.isRequired,
    animationFinished: PropTypes.func.isRequired,
    onScreen: PropTypes.bool
};

export default withOnScreen(Bar);
